module.exports = __webpack_public_path__ + "static/img/一种可拆卸更换土壤的花盆.0678fbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/一种可拆卸更换土壤的花盆.jpg
// module id = xVEx
// module chunks = 15